<div class="cart-control-form-settings">
  <div class="content">
    <div class="section">
      <pdq-heading element="h5">Settings</pdq-heading>
      <div class="controls-wrapper">
        <pdq-input
          [formControl]="formGroup.get('internalName')"
          label="Internal Name*"
          placeholder="Cart Control"
          [invalid]="formGroup.get('internalName')?.errors?.required"
          invalidMsg="Internal name is required"></pdq-input>
        <pdq-input
          [formControl]="formGroup.get('internalDescription')"
          label="Internal Description"
          placeholder="Cart Control"></pdq-input>
      </div>
    </div>
  </div>
</div>
